const Home = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 20">
      <path
        data-name="Caminho 12851"
        d="M10.4 20.85v-6.3h4.2v6.3h5.25v-8.4H23L12.5 3 2 12.45h3.15v8.4z"
        transform="translate(-2 -3)"
        style={{ fill: "#fff" }}
      />
    </svg>
  );
};

export default Home;
